import { useEffect, type ReactElement } from "react";
import { apexBuyerRedirect } from "@shared/host";
import { platformApex } from "@/lib/host";

/**
 * Gate for buyer auth + membership routes that must run on the apex, not on a
 * seller storefront host. See `apexBuyerRedirect` for the why (Turnstile 110200 +
 * per-origin Supabase sessions).
 *
 * On a real storefront host it hard-navigates to the same path on the apex; on the
 * app/apex or a local dev host (where `apexBuyerRedirect` returns null) it renders
 * `children` in place, so `?__store=` dev overrides keep working.
 */
export function ApexRedirect({ children }: { children: ReactElement }) {
  const { hostname, pathname, search, hash } = window.location;
  const target = apexBuyerRedirect(hostname, platformApex(), `${pathname}${search}${hash}`);

  useEffect(() => {
    if (target) window.location.replace(target);
  }, [target]);

  return target ? null : children;
}
